module.exports = __webpack_public_path__ + "static/media/clock.4ed07f09.svg";